'use strict';

var _ = require('lodash');
function FaresDataManagementFactory(restangular, $q) {
  function DataManagement(path) {
    this.service = createService(path);
    this.filters = [];
    this.aggregations = [];
    this.transformations = [];
    this.reducers = [];
  }
  DataManagement.prototype.retrieveData = function (query, path) {
    path = path || '';
    query = query || {};
    var retrievePromise = this.service.customGET(path, query);
    var self = this;
    return retrievePromise.then(function (data) {
      return promiseSerializer([self.apply('filters'), self.apply('aggregations'), self.apply('transformations'), self.apply('reducers')], data, self.transformationsData);
    });
  };
  DataManagement.prototype.save = function (data, params, headers, path, method) {
    data = data || {};
    params = params || {};
    headers = headers || {};
    path = path || '';
    method = getRequestMethod(method, 'save');
    return this.service[method].call(this.service, data, path, params, headers);
  };
  DataManagement.prototype.remove = function (data, params, headers, path, method) {
    data = data || {};
    params = params || {};
    headers = headers || {
      'Content-Type': 'application/json'
    };
    path = path || '';
    method = getRequestMethod(method, 'delete');
    return this.service[method].call(this.service, 'remove', path, params, headers, data);
  };
  DataManagement.prototype.apply = function (aggregationType) {
    var self = this;
    return function (data) {
      if (!_.size(self[aggregationType])) {
        return $q.when(data);
      }
      return promiseSerializer(self[aggregationType], data, self.transformationsData);
    };
  };
  DataManagement.prototype.add = function (type, transformer) {
    if (!_.isFunction(transformer) || !type || !_.includes(['filters', 'aggregations', 'transformations', 'reducers'], type)) {
      return;
    }
    this[type].push(transformer);
  };
  function getRequestMethod(requestedMethod, action) {
    var defaultMethods = {
      save: 'customPOST',
      "delete": 'customOperation'
    };
    if (!requestedMethod) {
      return defaultMethods[action];
    }
    return 'custom' + requestedMethod.toUpperCase();
  }
  function promiseSerializer(methods, data, transformationsData) {
    if (!methods.length) {
      return $q.when(data);
    }
    return _.reduce(methods, function (queue, method) {
      return queue.then(function (data) {
        var promisedValue = method.call(null, data, transformationsData);
        if (!_.isFunction(promisedValue.then)) {
          return $q.when(promisedValue);
        }
        return promisedValue;
      });
    }, $q.when(data));
  }
  function createService(path) {
    var service = restangular;
    var splittedPath = path.split('/');
    return _.reduce(splittedPath, function (service, path) {
      return service.one(path);
    }, service);
  }
  return DataManagement;
}
FaresDataManagementFactory.$inject = ['Restangular', '$q'];
module.exports = FaresDataManagementFactory;